$(document).ready(function () {
  console.log("Test");
  // Handle all buttons with .open-lightbox class
  $('.open-lightbox').click(function () {
    console.log("Tst");
    const contentId = $(this).data('content');
   // const html = $(contentId).html();
   //$('.lightbox-body').html(html);
    $(contentId).fadeIn();
  });

  // Close the lightbox
  $('.close-lightbox').click(function() {
    $('.lightbox-overlay').fadeOut();
  });

  $('.lightbox-overlay').click(function (e) {
      if (!$(e.target).closest('.lightbox-content').length) {
        $('.lightbox-overlay').fadeOut();
      }
  });
});